import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import PlatformHubTabs from "../components/PlatformHubTabs";
import { api } from "../lib/api";
import { ShoppingBag, DollarSign, Package, Settings, Save, ToggleLeft, ToggleRight, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function IntimalyHub() {
  const [stats, setStats] = useState({ sales: 0, revenue: 0, products: 0 });
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [useManualData, setUseManualData] = useState(true);
  const [manualStats, setManualStats] = useState({ sales: 0, revenue: 0, products: 0 });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [statsRes, settingsRes] = await Promise.all([api.get("/api/platform-hubs/intimaly/stats"), api.get("/api/platform-hubs/intimaly/settings")]);
      setStats(statsRes.data || stats);
      if (settingsRes.data) {
        setUseManualData(settingsRes.data.use_manual_data ?? true);
        setManualStats(settingsRes.data.manual_stats || manualStats);
      }
    } catch (e) { console.error(e); }
  };

  const saveManualStats = async () => {
    try { await api.post("/api/platform-hubs/intimaly/manual-stats", { stats: manualStats }); toast.success("Stats saved!"); loadData(); } catch (e) { toast.error("Failed"); }
  };

  const displayStats = useManualData ? manualStats : stats;

  return (
    <AppLayout title="Intimaly Hub" overline="Platform Hub · Toy Sales" actions={
      <div className="flex gap-2">
        <button onClick={() => setSettingsOpen(!settingsOpen)} className="btn-ghost inline-flex items-center gap-2 backdrop-blur-xl bg-black/40 border border-white/20 text-white"><Settings size={16} />Settings</button>
        <a href="https://intimaly.com/giopilos" target="_blank" rel="noopener noreferrer" className="btn-ghost inline-flex items-center gap-2 backdrop-blur-xl bg-black/40 border border-white/20 text-white"><ExternalLink size={14} />Open Intimaly</a>
      </div>
    }>
      <PlatformHubTabs platform="intimaly" platformName="Intimaly">
      {settingsOpen && (
        <div className="mb-6 backdrop-blur-xl bg-pink-900/20 border border-white/10 rounded-lg p-6">
          <h3 className="text-lg font-bold text-white mb-4">Intimaly Settings</h3>
          {useManualData && (
            <div className="mt-4 p-4 rounded-lg bg-black/40 border border-white/10">
              <h4 className="font-semibold text-white mb-4">Manual Stats</h4>
              <div className="grid grid-cols-3 gap-4">
                <div><label className="block text-xs text-zinc-400 mb-1">Sales</label><input type="number" value={manualStats.sales} onChange={(e) => setManualStats({...manualStats, sales: parseInt(e.target.value) || 0})} className="w-full px-3 py-2 rounded bg-black/60 border border-white/10 text-white"/></div>
                <div><label className="block text-xs text-zinc-400 mb-1">Revenue ($)</label><input type="number" step="0.01" value={manualStats.revenue} onChange={(e) => setManualStats({...manualStats, revenue: parseFloat(e.target.value) || 0})} className="w-full px-3 py-2 rounded bg-black/60 border border-white/10 text-white"/></div>
                <div><label className="block text-xs text-zinc-400 mb-1">Products</label><input type="number" value={manualStats.products} onChange={(e) => setManualStats({...manualStats, products: parseInt(e.target.value) || 0})} className="w-full px-3 py-2 rounded bg-black/60 border border-white/10 text-white"/></div>
              </div>
              <button onClick={saveManualStats} className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"><Save size={16} />Save</button>
            </div>
          )}
        </div>
      )}
      <div className="grid grid-cols-3 gap-4">
        <div className="backdrop-blur-xl bg-black/40 border border-white/10 rounded-lg p-6"><div className="flex items-center gap-3 mb-2"><ShoppingBag size={24} className="text-pink-400" /><div className="text-sm text-zinc-400">Total Sales</div></div><div className="text-3xl font-bold text-white">{displayStats?.sales || 0}</div></div>
        <div className="backdrop-blur-xl bg-black/40 border border-white/10 rounded-lg p-6"><div className="flex items-center gap-3 mb-2"><DollarSign size={24} className="text-green-400" /><div className="text-sm text-zinc-400">Revenue</div></div><div className="text-3xl font-bold text-white">${(displayStats?.revenue || 0).toFixed(2)}</div></div>
        <div className="backdrop-blur-xl bg-black/40 border border-white/10 rounded-lg p-6"><div className="flex items-center gap-3 mb-2"><Package size={24} className="text-purple-400" /><div className="text-sm text-zinc-400">Products</div></div><div className="text-3xl font-bold text-white">{displayStats?.products || 0}</div></div>
      </div>
      </PlatformHubTabs>
    </AppLayout>
  );
}